import React, { useEffect, useRef, useState } from "react";
import TractorConfigurator from "./TractorConfigurator";
import TractorTires from "./TractorTires";
import TractorUpgrade from "./TractorUpgrade";
import TractorAttachment from "./TractorAttachment";
import TractorEquiment from "./TractorEquiment";
import TractorAccessories from "./TractorAccessories";
import TractorReview from "./TractorReview";
import {useTranslation} from "react-i18next";

const steps = [
  { id: 1, title: "choose_tractor" },
  { id: 2, title: "choose_tires" },
  { id: 3, title: "choose_upgrades" },
  { id: 4, title: "choose_attachments" },
  { id: 5, title: "choose_equipment" },
  { id: 6, title: "choose_accessories" },
  { id: 7, title: "review_your_package" },
];

const Configuration = () => {
  const { t } = useTranslation();
  const stepRefs = useRef([]);
  const containerRef = useRef(null);

  const [currentStep, setCurrentStep] = useState(1);

  useEffect(() => {
    if (stepRefs.current[currentStep - 1]) {
      stepRefs.current[currentStep - 1].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [currentStep]);

  const handleStepChange = (step) => {
    setCurrentStep(step);
  };

  return (
    <section className="configuration-section">
      <div className="container-fluid p-0">
        <div className="bg-white border-bottom sticky top-0 z-10">
          <div className="container py-3 custom-scrollbar overflow-auto">
            <div
              className="d-flex align-items-center flex-nowrap"
              ref={containerRef}
            >
              {steps.map((step, index) => {
                const isActive = step.id === currentStep;
                const isCompleted = step.id < currentStep;
                const isDisabled = step.id > currentStep;

                return (
                  <React.Fragment key={step.id}>
                    <button
                      ref={(el) => (stepRefs.current[index] = el)}
                      className={`btn d-flex align-items-center me-2 text-sm cursor-pointer ${
                        isActive
                          ? "step-button-selected"
                          : isCompleted
                          ? "step-button-unselected"
                          : "step-button-disabled"
                      }`}
                      onClick={() => {
                        if (!isDisabled) {
                          handleStepChange(step.id);
                        }
                      }}
                      disabled={isDisabled}
                      title={isDisabled ? "Step disabled" : ""}
                    >
                      <div
                        className={`rounded-circle d-flex align-items-center justify-content-center font-bold me-2 step-circle ${
                          isActive
                            ? "step-active"
                            : isCompleted
                            ? "step-completed"
                            : "step-default"
                        }`}
                      >
                        {isCompleted ? (
                          <i className="bi bi-check2"></i>
                        ) : (
                          step.id
                        )}
                      </div>
                      <span className="d-none d-md-inline step-title">
                        {t(step.title)}
                      </span>
                    </button>

                    {index < steps.length - 1 && (
                      <div className="step-connector flex-shrink-0" />
                    )}
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        </div>

        <div className="container py-4">
          {currentStep === 1 && (
            <TractorConfigurator setCurrentStep={setCurrentStep} />
          )}
          {currentStep === 2 && (
            <TractorTires setCurrentStep={setCurrentStep} />
          )}
          {currentStep === 3 && (
            <TractorUpgrade setCurrentStep={setCurrentStep} />
          )}
          {currentStep === 4 && (
            <TractorAttachment setCurrentStep={setCurrentStep} />
          )}

          {currentStep === 5 && (
            <TractorEquiment setCurrentStep={setCurrentStep} />
          )}

          {currentStep === 6 && (
            <TractorAccessories setCurrentStep={setCurrentStep} />
          )}
          {currentStep === 7 && (
            <TractorReview setCurrentStep={setCurrentStep} />
          )}
        </div>
      </div>
    </section>
  );
};

export default Configuration;
